import React, { useState } from 'react'
import PlacesAutocomplete from 'react-places-autocomplete';
import styled from 'styled-components';
const Wrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 18px;
  height: 18px;
  background-color: beige;
  /* border: 2px solid #fff; */
  border-radius: 100%;
  user-select: none;
  transform: translate(-50%, -50%);
  cursor: pointer;

  .active-pin {
    filter: saturate(0) brightness(2) invert(1);
  }
  .inactive-pin {
    filter: invert(0);
  }
`;


const Marker = ({ text, onClick, lat, lng,selectedLat,selectedLng, setSelectedLat, setSelectedLng, }) => (
  <Wrapper >
    <img src="https://dl3.pushbulletusercontent.com/G2IRfX1bq3zASFKBNwBOwSQggwauzgfW/BrownPinMarker-2.png" className={ lat===selectedLat&&lng===selectedLng ? 'active-pin' : 'inactive-pin'} style={{ maxWidth: '2em'}} alt="" />
  </Wrapper>
);
// https://upload.wikimedia.org/wikipedia/commons/thumb/d/d1/Google_Maps_pin.svg/585px-Google_Maps_pin.svg.png


export default Marker